import * as stateManagement from '#packages/stateManagement';
import type { PublishSuccessPanelDispatchProps } from './publishSuccessPanelTypes';
import type { Dispatch, StateMapperArgs } from 'types/redux';

function mapDispatchToProps(
  dispatch: Dispatch,
): PublishSuccessPanelDispatchProps {
  return {
    showUserActionNotification: (options) =>
      dispatch(
        stateManagement.notifications.actions.showUserActionNotification(
          options,
        ),
      ),
    setWasLatestRCPublished: (wasLatestRCPublished: boolean) =>
      dispatch(
        stateManagement.savePublish.actions.setWasLatestRCPublished(
          wasLatestRCPublished,
        ),
      ),
  };
}

function mapStateToProps({ editorAPI }: StateMapperArgs) {
  const { store } = editorAPI;
  const editorState = store.getState();
  return {
    wasLatestRCPublished:
      stateManagement.savePublish.selectors.getWasLatestRCPublished(
        editorState,
      ),
  };
}

export { mapStateToProps, mapDispatchToProps };
